




export default {
    props: ["close"]
}
